export default "__VITE_ASSET__BRmPqesp__"